import * as React from "react";

export default {

    returnAkcjaDowolnaHtml(nazwa = 'Usuń', kolor = 'firebrick') {
        return (<div style={{fontSize: '12px'}}>
            <span style={{color: kolor}}>{nazwa}</span>
        </div>)
    },

    returnDwieDowolneAkcjeHtml(nazwa = 'Usuń', kolor = 'firebrick', nazwa2 = 'Edytuj', kolor2 = 'black') {
        return (<div style={{fontSize: '12px'}}>
            <span style={{color: kolor}}>{nazwa}</span>
            <span style={{color: '#ccc', margin: '0 3px'}}>|</span>
            <span style={{color: kolor2}}>{nazwa2}</span>
        </div>)
    },

    returnTrzyDowolneAkcjeHtml(nazwa = 'Usuń', kolor = 'firebrick', nazwa2 = 'Edytuj', kolor2 = 'black', nazwa3 = 'Akcja', kolor3 = 'black') {
        return (<div style={{fontSize: '12px'}}>
            <span style={{color: kolor}}>{nazwa}</span>
            <span style={{color: '#ccc', margin: '0 3px'}}>|</span>
            <span style={{color: kolor2}}>{nazwa2}</span>
            <span style={{color: '#ccc', margin: '0 3px'}}>|</span>
            <span style={{color: kolor3}}><div>{nazwa3}</div></span>
        </div>)
    },

    returnAkcjaUsunDowolnaHtml(nazwa = 'Akcja', kolor = 'grey') {
        return (<div style={{fontSize: '12px'}}>
            <span style={{color: kolor}}>{nazwa}</span>
            <span style={{color: '#ccc', margin: '0 3px'}}>|</span>
            <span style={{color: 'firebrick'}}>Usuń</span>
        </div>)
    },


    returnAkcjeEdytujUsunHtml() {
        return (<div style={{fontSize: '12px'}}>
            <span style={{color: 'grey'}}>Edytuj</span>
            <span style={{color: '#ccc', margin: '0 3px'}}>|</span>
            <span style={{color: 'firebrick'}}>Usuń</span>
        </div>)
    },

    returnAkcjeEdytujUsunPlusDodatkowaHtml(nazwa = 'Pokaż', kolor = '#333333') {
        return (<div style={{fontSize: '12px'}}>
            <span style={{color: kolor}}>{nazwa}</span>
            <span style={{color: '#ccc', margin: '0 3px'}}>|</span>
            <span style={{color: 'grey'}}>Edytuj</span>
            <span style={{color: '#ccc', margin: '0 3px'}}>|</span>
            <span style={{color: 'firebrick'}}>Usuń</span>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/utilities/TabUtilities.js